export default __webpack_public_path__ + "static/marking-b9d17cd80942b946fa962dbbca1aaec2.png";